import { Component, OnInit, inject, model, viewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';

import { BaseComponent, BaseEditFormModalComponent, FormlyService, IdDescription } from 'tms-lib';
import {
  ShipperInterfaceDetails,
  ShipperInterfaceDetailsService,
  ShippingPack,
  ShippingPackReferenceService,
  ShippingPackService,
} from 'tms-web-shared';

@Component({
  selector: 'app-shipper-interface-details-modal',
  templateUrl: './shipper-interface-details-modal.component.html',
  styleUrl: './shipper-interface-details-modal.component.scss',
  imports: [BaseEditFormModalComponent],
})
export class ShipperInterfaceDetailsModalComponent extends BaseComponent implements OnInit {
  protected readonly shipperInterfaceDetailsService = inject(ShipperInterfaceDetailsService);
  protected readonly shippingPackService = inject(ShippingPackService);
  private readonly shippingPackReferenceService = inject(ShippingPackReferenceService);
  private readonly formlyService = inject(FormlyService);

  private readonly form = viewChild(BaseEditFormModalComponent);
  public readonly id = model<string>();
  public readonly shippingInterfaceHeaderId = model<string>();
  public readonly shipperSupplierId = model<string>();

  protected fields: FormlyFieldConfig[];
  protected model: ShipperInterfaceDetails;

  private shippingPacks$: Observable<IdDescription[]>;

  ngOnInit() {
    this.shippingPacks$ = this.shippingPackReferenceService.getForShipper(this.shipperSupplierId());
    this.getFields();
  }

  private getFields() {
    this.fields = [
      this.formlyService.select('shippingPackId', $localize`Shipping Pack`, this.shippingPacks$, {
        required: true,
        change: (field: FormlyFieldConfig, event) => this.changeShippingPack(event?.value),
      }),
      this.formlyService.number('grossWeight', $localize`Weight`, { required: true }),
      this.formlyService.number('length', $localize`Length`, { required: true }),
      this.formlyService.number('width', $localize`Width`, { required: true }),
      this.formlyService.number('height', $localize`Height`, { required: true }),
    ];
  }

  private changeShippingPack(shippingPackId: string) {
    this.shippingPackService
      .edit(shippingPackId)
      .pipe(this.untilDestroyed())
      .subscribe((model: ShippingPack) => this.form().updateModel(model, true));
  }
}
